export const pipe =
  (...fns: Array<(a: any) => any>) =>
  (a: any) =>
    fns.reduce((v, f) => f(v), a);
